import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { createTheme, useTheme, ThemeProvider } from '@mui/material/styles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Autocomplete": Autocomplete, "@mui/material/Box": Box, "@mui/material/Stack": Stack, "@mui/material/TextField": TextField, "@mui/material/styles": { createTheme, useTheme, ThemeProvider } } } });
export default ClientProvider;
